import { fromJS } from 'immutable';
import * as types from './Types';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core';

const initialState = fromJS({
  page: {}
});

const RenunciaReceitasReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FIND_RENUNCIA_RECEITAS_START:
      return startLoad(state);
    case types.FIND_RENUNCIA_RECEITAS_SUCCESS:
      return endLoad(state.set('page', fromJS(action.payload)));
    case types.FIND_RENUNCIA_RECEITAS_ERROR:
      return endLoad(state);
    default:
      return state;
  }
};

export default RenunciaReceitasReducer;
